import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { ApiService } from './api.service';
import { Token, Admin } from '../../shared/models';
import { Constant } from '../constants/constant';

@Injectable()
export class AuthService {
    jwt_token = 'auth-token';
    refresh_token = 'refresh-token';
    rememberUser = 'remember-user';
    authUserInfo = 'user-data';
    userInfo = 'user-data-auth';
    base_url = Constant.new_base_url;
    public socket: any;
    constructor(
        private http_client: ApiService,
        private router: Router,
    ) { }

    getAuthToken() {
        return localStorage.getItem(this.jwt_token) || null;
    }

    setAuhToken(token: string) {
        localStorage.setItem(this.jwt_token, token);
    }

    setRefreshToken(refreshToken: string) {
        localStorage.setItem(this.refresh_token, refreshToken);
    }

    getRefreshToken() {
        return localStorage.getItem(this.refresh_token) || null;
    }

    destroyToken() {
        window.localStorage.removeItem(this.jwt_token);
    }

    keepLoggedIn() {
        localStorage.setItem(this.rememberUser, 'true');
    }

    getRememberUser() {
        return localStorage.getItem(this.rememberUser) || null;
    }

    refreshToken() {
        const token: Token = new Token();
        token.token = this.getAuthToken();
        token.refresh_token = this.getRefreshToken();
        return 'ssd';
    }

    setUserInfoAuth(userInfo: Admin) {
        localStorage.setItem(
            this.userInfo,
            userInfo ? btoa(JSON.stringify(userInfo)) : ''
        );
    }

    getUserInfoAuth(): Admin {
        if (localStorage.getItem(this.userInfo) !== null && localStorage.getItem(this.userInfo) !== '') {
            return JSON.parse(atob(localStorage.getItem(this.userInfo)));
        } else {
            return null;
        };
    }

    logout() {
        this.setAuhToken('');
        this.setUserInfoAuth(null);
        this.setRefreshToken('');
        this.router.navigate(['/login']);
    }

    login(admin: Admin): Promise<any> {
        return this.http_client.postData(this.base_url + 'api/Users/authenticate', admin)
            .then((res: any) => {
                if (res && res.userName) {
                    this.setAuhToken(res.userToken);
                    this.setUserInfoAuth(res);
                }
                return res;
            }).catch(error => {
                console.log(error);
                throw error;
            })
    }
}
